import * as React from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  required,
  ReferenceInput,
  SelectInput,
  DateInput,
  NumberInput,
  ArrayInput,
  SimpleFormIterator,
  minValue
} from 'react-admin'
import { Box, Typography } from '@mui/material'
import moment from 'moment'

const ProviderContractCreate = (props) => {
  const defaultValues = {
    billingPeriod: 'monthly',
    startDate: moment().format('YYYY-MM-DD'),
    customerPrice: 0,
    daysToConvert: 84,
    pricingTiers: [{ minVolume: 0, pricePerKitShipped: 42.00, pricePerKitTested: 26.00 }]
  }

  return (
    <Create {...props} title="Create New Provider Contract">
      <SimpleForm defaultValues={defaultValues}>
        <Box width="100%">
          <Typography variant="h6" gutterBottom>Contract Details</Typography>
          <Box display="flex" gap={2} mb={2}>
            <ReferenceInput source="providerGroupId" reference="provider-groups" label="Provider Group">
              <SelectInput optionText="name" fullWidth validate={[required()]} />
            </ReferenceInput>
          </Box>
          <Box display="flex" gap={2} mb={2}>
            <DateInput source="startDate" label="Start Date" validate={[required()]} />
            <DateInput source="endDate" label="End Date (optional)" />
          </Box>
          <Box display="flex" gap={2} mb={2}>
            <SelectInput source="billingPeriod" label="Billing Period" validate={[required()]} choices={[
              { id: 'monthly', name: 'Monthly' },
              { id: 'quarterly', name: 'Quarterly' },
              { id: 'yearly', name: 'Yearly' },
            ]} />
            <NumberInput
              source="customerPrice"
              label="Customer Price"
              validate={[minValue(0)]}
              min={0}
              onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()}
            />
            <NumberInput
              source="daysToConvert"
              label="Days to Convert"
              validate={[required(), minValue(1)]}
              min={1}
              onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()}
            />
          </Box>

          <Typography variant="subtitle2" gutterBottom>B2B Pricing Tiers</Typography>
          <ArrayInput source="pricingTiers" label="">
            <SimpleFormIterator disableReordering>
              <NumberInput
                source="minVolume"
                label="Minimum Volume"
                validate={[required(), minValue(0)]}
                min={0}
                onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()}
              />
              <NumberInput
                source="pricePerKitShipped"
                label="Price per Kit Shipped"
                options={{ style: 'currency', currency: 'USD' }}
                validate={[required(), minValue(0)]}
                min={0}
                onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()}
              />
              <NumberInput
                source="pricePerKitTested"
                label="Price per Kit Tested"
                options={{ style: 'currency', currency: 'USD' }}
                validate={[required(), minValue(0)]}
                min={0}
                onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()}
              />
            </SimpleFormIterator>
          </ArrayInput>
        </Box>
      </SimpleForm>
    </Create>
  )
}

export default ProviderContractCreate
